var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 3.66665H7.66634V4.99998H6.33301V3.66665ZM6.33301 6.33331H7.66634V10.3333H6.33301V6.33331ZM6.99967 0.333313C3.31967 0.333313 0.333008 3.31998 0.333008 6.99998C0.333008 10.68 3.31967 13.6666 6.99967 13.6666C10.6797 13.6666 13.6663 10.68 13.6663 6.99998C13.6663 3.31998 10.6797 0.333313 6.99967 0.333313ZM6.99967 12.3333C4.05967 12.3333 1.66634 9.93998 1.66634 6.99998C1.66634 4.05998 4.05967 1.66665 6.99967 1.66665C9.93967 1.66665 12.333 4.05998 12.333 6.99998C12.333 9.93998 9.93967 12.3333 6.99967 12.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.649dc170cdc7ddbb11d3d7617dcd50ef.svg";
export { ForwardRef as ReactComponent };